import { BoxProps, TextProps } from '@jfs/ui-new'
import { ImageStyle, ViewStyle } from 'react-native'

export const shadowStyle = {
  shadowColor: 'BLUE',
  shadowOffset: {
    width: 1,
    height: 2,
  },
  shadowOpacity: 0.2,
  shadowRadius: 4,
  zIndex: 1,
}

const shadowStyle1 = {
  shadowOffset: { width: 1, height: 2 },
  shadowRadius: 5,
  shadowColor: '#0000001F',
  borderRadius: 24,
  borderWidth: 1,
  borderColor: '#00000014',
  zIndex: 10,
}

export const styles = {
  parent: { flex: 1, width: '100%', height: '100%' } as ViewStyle,
  container: {
    width: '100%',
    height: '100%',
    backgroundColor: 'WHITE',
    alignItems: 'center',
  } as BoxProps,
  scrollviewStyle: {
    flexGrow: 1,
    backgroundColor: 'white',
  },
  qrImgcontainer: {
    // width: '100%',
    marginTop: 15,
    align: 'center',
    justify: 'center',
    marginBottom: 6,
  } as BoxProps,
  amtInput: {
    width: '75%',
    mt: 40,
    borderWidth: 1,
    borderColor: 'BLUE',
    borderRadius: 6,
    underlayColor: 'WHITE',
    pv: 15,
    bg: 'WHITE',
    ...shadowStyle,
  } as BoxProps,
  imageView: { width: 200, height: 200, borderRadius: 8 },
  upisize: { width: 100, height: 20, resizeMode: 'contain' } as ImageStyle,
  qrcodeText: {
    fontSize: 12,
    color: 'LIGHT_BLACK',
    textAlign: 'center',
    lineHeight: 19,
  } as TextProps,
  orWrapper: {
    mt: 20,
    flexDirection: 'row',
  } as BoxProps,
  lineView: {
    width: '80%',
    alignSelf: 'center',
    height: 1,
    mt: 30,
    bg: 'SEPERATOR',
    // marginY: 16,
  } as BoxProps,
  imgStyle: { width: '100%', height: '100%' },
  progressEmptyView: {
    width: '100%',
    height: 200,
    paddingVertical: 100,
  } as BoxProps,
  bhim: {
    display: 'flex',
    // minWidth: '30%',
    marginVertical: 5,
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
  amountEntered: {
    underlayColor: 'LIGHTEST_GREY',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: 16,
  } as BoxProps,
  editIcons: {
    width: 30,
    height: 30,
    borderRadius: 30,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 3,
    borderColor: 'WHITE',
  } as BoxProps,
  editIconsWrapper: {
    mt: 20,
    mb: 20,
    justify: 'center',
    alignItems: 'center',
    paddingVertical: 5,
    paddingLeft: 8,
    paddingRight: 4,
    flexDirection: 'row',
    flexWrap: 'nowrap',
    ...shadowStyle1,
    overflow: 'hidden',
  } as BoxProps,
  ripple1: (size = 100) =>
  ({
    backgroundColor: 'PRIMARY',
    opacity: 0.3,
    width: size,
    height: size,
    borderRadius: size / 2,
    position: 'absolute',
  } as BoxProps),
  ripple2: (size = 130) =>
  ({
    backgroundColor: 'PRIMARY',
    opacity: 0.2,
    width: size,
    height: size,
    borderRadius: size / 2,
    position: 'absolute',
  } as BoxProps),
}
